import * as fromProgramSearchResults from '../actions/program-searchresults.action';
import * as fromModels from '../../models';
import { HttpHeaders } from '@angular/common/http';

export interface SearchResultsState {
    searchResults: fromModels.ProgramSearchResultsItem[];
    searchCriteria: fromModels.ProgramSearchCriteria;
    pagingSorting: fromModels.ProgramPagingSorting;
    errors: any;	//	TODO: formalize error handling
    loading: boolean;
    loaded: boolean;
}

export const initialState: SearchResultsState = {
    loading: false,
    loaded: false,
    searchResults: null,
    errors: null,
    searchCriteria: {
        teacherId: null,
        schoolId: null,
        PageNumber: null,
        PageSize: null,
        SortBy: null,
        SortDir: null,
    },
    pagingSorting: {
        totalCount: null,
        pageSize: null,
        currentPage: null,
        totalPages: null,
        sortBy: null,
        sortDir: null
    }
};

export function reducer(state = initialState, action: fromProgramSearchResults.ProgramSearchResultsActions): SearchResultsState {
    switch (action.type) {
        case fromProgramSearchResults.ProgramSearchResultsActionTypes.ProcessQueryString: {
            console.log('ProcessQueryString');
            console.log(action.payload);

            return {
                ...state,
                loaded: false,
                loading: false,
                errors: null
            };
        }

        case fromProgramSearchResults.ProgramSearchResultsActionTypes.LoadProgramSearchResults: {
            console.log('LoadProgramSearchResults');
            console.log(action.payload);
			return {
                ...state,
                loaded: false,
                loading: true,
                errors: null,
                // Anytime we request search results, let's update the state to include that
                // most recent criteria that was just passed.
                searchCriteria: action.payload
			};
		}

        case fromProgramSearchResults.ProgramSearchResultsActionTypes.LoadProgramSearchResultsSuccess: {
            const searchResults = action.payload;
            const headers = action.httpHeaders;

			return {
                ...updateProgramSearchResultsState(state, searchResults, headers),
				loaded: true,
                loading: false
			};
		}

        case fromProgramSearchResults.ProgramSearchResultsActionTypes.LoadProgramSearchResultsFailure: {
			console.log('reducer:', action);

			return {
				...state,
				loaded: false,
				loading: false,
                errors: action.payload
			};
        }
	}

	return state;
}

function updateProgramSearchResultsState(state: SearchResultsState, searchResults: fromModels.ProgramSearchResultsItem[], headers: HttpHeaders) {
    let pagingSorting: fromModels.ProgramPagingSorting;

    // Grab special header we use for paging
    const pagingHeader: string = headers.get('X-Pagination');
    const pagingObject: object = JSON.parse(pagingHeader);

    // Populate paging information from http headers
    pagingSorting = {
        totalCount: pagingObject['totalCount'],
        pageSize: pagingObject['pageSize'],
        currentPage: pagingObject['currentPage'],
        totalPages: pagingObject['totalPages'],
        sortBy: pagingObject['sortBy'],
        sortDir: pagingObject['sortDir']
    };

	return {
		...state,
        searchResults,
        pagingSorting
	};
}

export const getProgramSearchResults = (state: SearchResultsState) => state.searchResults;
export const getProgramSearchLoading = (state: SearchResultsState) => state.loading;
export const getProgramSearchLoaded = (state: SearchResultsState) => state.loaded;
export const getProgramSearchErrors = (state: SearchResultsState) => state.errors;
